<div *ngIf="(profileState | async).mediaAnalyze !== null">
  <div [ngClass]="!(profileState | async).loader['audit']['mediaAnalyze'] ? 'background-loader' : ''">
    <div class="spinner" *ngIf="!(profileState | async).loader['audit']['mediaAnalyze']"></div>
    <h3 class="card-header">
      Hashtags
      <a data-tooltip="Most frequently used #hashtags on this profile. Reveals main content themes and engagement strategies.">
        <img class="icon-info" src="./assets/images/icons/info.png" />
      </a>
    </h3>
    <div class="mt-3 box-md" *ngIf="(profileState | async).mediaAnalyze.hashtag_rank !== undefined">
      <div class="table-responsive">
        <table class="table table-bordered mb-0">
          <thead>
          <tr>
            <th class="number">#</th>
            <th>Profile</th>
            <th>Uses</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let hashtag of (profileState | async).mediaAnalyze.hashtag_rank.buckets; let i = index;">
            <td>{{i + 1}}.</td>
            <td class="hashtag-line">
              <span class="font-weight-semibold font-size-15">#{{hashtag.key}}</span>
            </td>
            <td>{{hashtag.doc_count}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
